import Button from 'components/Button/index'
import InfoCards from 'components/InfoCards'
import Select from 'components/Select'
import ClosedRoles from 'components/icons/ClosedRoles'
import EntryLevel from 'components/icons/EntryLevel'
import Internship from 'components/icons/Internship'
import OpenRoles from 'components/icons/OpenRoles'
import PlusIcon from 'components/icons/PlusIcon'
import WorkIcon from 'components/icons/WorkIcon'
import RolesFilter from 'modules/Roles/Partials/RolesFilter'
import RolesTable from 'modules/Roles/Partials/RolesTable'
import {
  CardRow,
  PaddedDiv,
  SectionWrapper,
  TopHeader,
  TopHeading,
} from 'modules/Roles/Style/style'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { COLORS } from 'theme'
import { permittedCruds } from '../../utils/permissionsValidation'

const Roles = ({
  getJobsList,
  corporateMetrics,
  jobsList,
  closeApplication,
  duplicateRole,
  deleteRole,
  currentJobId,
  getSingleRoleData,
  setEditingRole,
  setCurrentJobId,
  setSingleRoleData,
  setEditRoleOnView,
  setPreviewRoleData,
  dashboardNavs,
  setDashboardNavs,
  permissions,
  getNotificationCatalogues,
  getRoleDraftData,
  setDraftData,
  
}) => {
  const navigate = useNavigate()
  const tableRef = useRef(null)
  let pageLimit = 10
  const [cardsData, setCardsData] = useState([])
  const [pageNum, setPageNum] = useState(0)

  const [searchValue, setSearchValue] = useState('')
  const [filterData, setFilterData] = useState({
    jobType: '',
    jobTypeLevel: '',
    postedOnStart: '',
    postedOnEnd: '',
    status: '',
    label: '',
  })
  const [jobTypeLevel, setJobTypeLevel] = useState([])
  const [jobType, setJobType] = useState([])
  const [postedDate, setPostedDate] = useState({
    postedStart: '',
    postedEnd: '',
  })
  const [filterStatus, setFilterStatus] = useState([])
  const [loading, setLoading] = useState(false)

  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('')

  useEffect(() => {
    let pageNum = 0
    setPageNum(0)
    if (!dashboardNavs) {
      getJobsList({
        searchValue,
        filterData,
        pageNum,
        sortby: sortBy,
        orderby: orderBy,
        limit: pageLimit || 10,
        setLoading,
      })
    }
  }, [searchValue, filterData, sortBy, orderBy])
  useEffect(() => {
    if (!dashboardNavs) {
      getRoleData()
    }
  }, [pageNum])
  const getRoleData = () => {
    getJobsList({
      searchValue,
      filterData,
      pageNum,
      sortby: sortBy,
      orderby: orderBy,
      limit: pageLimit || 10,
      setLoading,
    })
  }

  useEffect(() => {
    const cardData = [
      {
        key: 1,
        icon: <OpenRoles />,
        text: 'Active Roles',
        value: corporateMetrics?.open_count,
        state: '1',
        current: filterData?.status,
      },
      {
        key: 2,
        icon: <EntryLevel />,
        text: 'Entry Level',
        value: corporateMetrics?.entry_count,
        state: 'ENTRY',
        current: filterData?.jobTypeLevel,
      },
      {
        key: 3,
        icon: <Internship />,
        text: 'Internship',
        value: corporateMetrics?.intern_count,
        state: 'INTERN',
        current: filterData?.jobTypeLevel,
      },
      {
        key: 4,
        icon: <WorkIcon />,
        text: 'Experienced',
        value: corporateMetrics?.experience_count,
        state: 'EXPERIENCED',
        current: filterData?.jobTypeLevel,
      },
      {
        key: 5,
        icon: <ClosedRoles />,
        text: 'Closed Roles',
        value: corporateMetrics?.closed_count,
        state: '-1',
        current: filterData?.status,
      },
    ]
    setCardsData(cardData)
  }, [corporateMetrics])

  useEffect(() => {
    setEditingRole(false)
    setCurrentJobId('')
    setSingleRoleData({})
    setDraftData('')
    setEditRoleOnView(false)
    setPreviewRoleData({})
    if (dashboardNavs) {
      let selectedOption = optionData?.find(item => item.value == dashboardNavs)
      setFilterData(prev => {
        return {
          ...prev,
          status: dashboardNavs,
          label: selectedOption?.label,
        }
      })
    }

    return setDashboardNavs(null)
  }, [])

  const optionData = [
    {
      value: 'ALL',
      label: 'All Roles',
    },

    {
      value: '1',
      label: 'Active Roles',
    },
    {
      value: '-1',
      label: 'Closed Roles',
    },
    {
      value: '0',
      label: 'Draft',
    },
  ]

  const onCardClick = card => {
    let selectedOption = optionData?.find(item => item.value == card)
    clearAll()
    if (card === '1' || card === '-1' || card === '0') {
      setFilterData({
        status: filterData?.status == card ? '' : card,
        label: selectedOption?.label,
      })
      filterData?.status == card
        ? setFilterStatus([])
        : setFilterStatus([card?.toString()])
    }

    if (card == 'ENTRY' || card == 'INTERN' || card == 'EXPERIENCED') {
      setFilterData({
        jobTypeLevel: filterData?.jobTypeLevel == card ? '' : card,
      })
      filterData?.jobTypeLevel == card
        ? setJobTypeLevel([])
        : setJobTypeLevel([card.toString()])
    }
  }

  const clearAll = () => {
    setSearchValue('')
    setFilterData({
      jobType: '',
      jobTypeLevel: '',
      postedOnStart: '',
      postedOnEnd: '',
      status: '',
      label: '',
    })
    setJobTypeLevel([])
    setJobType([])
    setPostedDate({
      postedStart: '',
      postedEnd: '',
    })
    setFilterStatus([])
  }
  useEffect(() => {
    tableRef.current.scrollIntoView({
      behavior: 'smooth',
    })
  }, [pageNum])

  const cruds = permittedCruds(permissions, 'Roles')

  return (
    <SectionWrapper column>
      <PaddedDiv column ref={tableRef}>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Roles</TopHeading>
          {cruds?.includes('NEW ROLE') && (
            <Button.Primary
              height={'38px'}
              text={'New Role'}
              icon={<PlusIcon />}
              onClick={() => navigate('new-role')}
            />
          )}
        </TopHeader>
        <CardRow>
          {cardsData?.map(card => (
            <InfoCards
              key={card?.key}
              width={'25%'}
              height="130px"
              icon={card?.icon}
              text={card?.text}
              value={card?.value}
              state={card?.state}
              current={card?.current}
              onClick={() => onCardClick(card?.state)}
            />
          ))}
        </CardRow>
        <Select
          width={'160px'}
          OptionData={optionData}
          nameParam="label"
          valueParam="value"
          backgroundcolor={COLORS.GREY_T_98}
          defaultValue="ALL"
          value={
            filterData?.status == '1' ||
            filterData?.status == '-1' ||
            filterData?.status?.toString() == '0'
              ? filterData?.label
              : 'ALL'
          }
          onChange={value => onCardClick(value)}
        />
      </PaddedDiv>

      <RolesFilter
        jobsList={jobsList}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        filterData={filterData}
        setFilterData={setFilterData}
        jobTypeLevel={jobTypeLevel}
        setJobTypeLevel={setJobTypeLevel}
        jobType={jobType}
        setJobType={setJobType}
        postedDate={postedDate}
        setPostedDate={setPostedDate}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        setPageNum={setPageNum}
      />
      <RolesTable
        setPageNum={setPageNum}
        pageNum={pageNum}
        jobsList={jobsList}
        closeApplication={closeApplication}
        duplicateRole={duplicateRole}
        deleteRole={deleteRole}
        setSortBy={setSortBy}
        setOrderBy={setOrderBy}
        pageLimit={pageLimit}
        permittedCruds={cruds}
        clearAll={clearAll}
        getSingleRoleData={getSingleRoleData}
        roleTableloading={loading}
        setEditRoleOnView={setEditRoleOnView}
        getRoleDraftData={getRoleDraftData}
        getRoleData={getRoleData}
        currentJobId={currentJobId}
      />
    </SectionWrapper>
  )
}
export default Roles
